import { render, staticRenderFns } from "./NoResultMessageForList.vue?vue&type=template&id=0f48da2e&scoped=true&lang=pug&"
import script from "./NoResultMessageForList.vue?vue&type=script&lang=ts&"
export * from "./NoResultMessageForList.vue?vue&type=script&lang=ts&"
import style0 from "./NoResultMessageForList.vue?vue&type=style&index=0&id=0f48da2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48da2e",
  null
  
)

export default component.exports